import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import API from '../../api/api';
import { LOADING_STATUSES } from '../../constants/statuses';
import { getTokenData, isResponseSuccess } from 'src/utils/api';

export const loadAllBundles = createAsyncThunk(
  'bundles/load',
  async (_, { rejectWithValue }) => {
    try {
      const response = await API(getTokenData()).BASIC.BUNDLES.load();
      if (isResponseSuccess(response.status)) {
        return response.data || [];
      }
      return {};
    } catch (error) {
      return rejectWithValue(error.toString());
    }
  },
);

const initialState = {
  bundles: [],
  status: LOADING_STATUSES.IDLE,
};

const bundlesSlice = createSlice({
  name: 'bundles',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loadAllBundles.pending, (state) => {
        state.status = LOADING_STATUSES.LOADING;
      })
      .addCase(loadAllBundles.fulfilled, (state, action) => {
        state.bundles = action.payload;
        state.status = LOADING_STATUSES.SUCCEEDED;
      })
      .addCase(loadAllBundles.rejected, (state, action) => {
        state.status = LOADING_STATUSES.FAILED;
        state.error = action.payload;
      });
  },
});

export default bundlesSlice.reducer;
